// src/contexts/pedidos/TaxaEntregaContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchData, postData, putData, deleteData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';

const TaxaEntregaContext = createContext();

export const useTaxaEntrega = () => useContext(TaxaEntregaContext);

export const TaxaEntregaProvider = ({ children }) => {
    const [taxasEntrega, setTaxasEntrega] = useState([]);
    const [taxaEntregaDefault, setTaxaEntregaDefault] = useState(null);
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();

    const obterTaxaEntregaDefault = (listaTaxasEntrega = []) => {
        if (!listaTaxasEntrega.length) {
            return null;
        }

        return listaTaxasEntrega.find(taxaEntrega => taxaEntrega.valorDefault === true) || listaTaxasEntrega[0];
    };

    useEffect(() => {
        const fetchDataFromAPI = async () => {
            try {
                console.log('buscaTaxas');
                
                const result = await fetchData('/TaxaEntrega');
                setTaxasEntrega(result);
            } catch (error) {
                console.error("Erro ao buscar taxas de entrega:", error);
            }
        };
        fetchDataFromAPI();
    }, []);

    useEffect(() => {
        setTaxaEntregaDefault(obterTaxaEntregaDefault(taxasEntrega));
    }, [taxasEntrega]);

    const addTaxaEntrega = async (taxaEntrega) => {
        try {
            const result = await postData('/TaxaEntrega', taxaEntrega);
            setTaxasEntrega([...taxasEntrega, result]);
            showAlert('Taxa de Entrega adicionada com sucesso!');
        } catch (error) {
            console.error("Erro ao adicionar taxa de entrega:", error);
            showMessage('Erro ao adicionar taxa de entrega!\n' + error, 'danger');
        }
    };

    const updateTaxaEntrega = async (taxaEntrega) => {
        try {
            const result = await putData('/TaxaEntrega', taxaEntrega);
            setTaxasEntrega(taxasEntrega.map(t => t.id === result.id ? result : t));
            showAlert('Taxa de Entrega alterada com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar taxa de entrega:", error);
            showMessage('Erro ao atualizar taxa de entrega!\n' + error, 'danger');
        }
    };

    const deleteTaxaEntrega = async (id) => {
        try {
            await deleteData('/TaxaEntrega', { taxaEntregaId: id });
            setTaxasEntrega(taxasEntrega.filter(t => t.id !== id));
            showAlert('Taxa de Entrega excluída com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir taxa de entrega:", error);
            showMessage('Erro ao excluir taxa de entrega!\n' + error, 'danger');
        }
    };

    return (
        <TaxaEntregaContext.Provider value={{ taxasEntrega, taxaEntregaDefault, addTaxaEntrega, updateTaxaEntrega, deleteTaxaEntrega }}>
            {children}
        </TaxaEntregaContext.Provider>
    );
};
